import * as yup from "yup"

export const stockReserve = yup.object({
  observaciones: yup.string().required("Este campo es obligatorio").nullable(),
  fecha: yup.string().required("Este campo es obligatorio").nullable(),
})
